module.exports = __webpack_public_path__ + "static/media/shoppurple.64bd7650.svg";